module.exports = __webpack_public_path__ + "static/media/Material.001_baseColor.8f91a317.png";